<template>
  <el-dialog
    :visible.sync="changeHistoryVisible"
    title="修改历史"
    :append-to-body="true"
    :close-on-click-modal="false"
    custom-class="customWidthChangeHistory1"
  >
    <el-form>
    <el-col :span="24">
      <el-row class="content-panel">
        <el-row>
          <el-row :gutter="10" style="margin: 5px">
            <el-col :span="6">
              <el-form-item label="表名:">
                <el-input
                  size="mini"
                  placeholder=""
                  clearable
                  v-model="searchData.tableName"
                  :title="searchData.tableName"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="字段描述:">
                <el-input
                  size="mini"
                  placeholder=""
                  clearable
                  v-model="searchData.fieldDescription"
                  :title="searchData.fieldDescription"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="新值:">
                <el-input
                  size="mini"
                  placeholder=""
                  clearable
                  v-model="searchData.newValue"
                  :title="searchData.newValue"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="旧值:">
                <el-input
                  size="mini"
                  placeholder=""
                  clearable
                  v-model="searchData.oldValue"
                  :title="searchData.oldValue"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="margin: 5px">
            <el-col :span="6">
              <el-form-item label="修改人:">
                <el-input
                  size="mini"
                  placeholder=""
                  clearable
                  v-model="searchData.modifier"
                  :title="searchData.modifier"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="修改日期从:">
                    <el-date-picker
                      v-model="searchData.modifyTimeFrom"
                      title="点击输入修改日期开始时间"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions"
                      date-format="YYYY-MM-DD HH:mm:ss"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="修改日期到:">
                    <el-date-picker
                      v-model="searchData.modifyTimeTo"
                      title="点击输入修改日期截止时间"
                      align="right"
                      type="date"
                      style="width: 100%"
                      size="mini"
                      placeholder=""
                      :picker-options="pickerOptions"
                      date-format="YYYY-MM-DD HH:mm:ss"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6" style="padding-top: 17px">
              <el-row type="flex" justify="end" align="middle" :gutter="10" class="el-row-margin">
                <el-button class="el-button-search" type="primary" size="small" plain @click="queryChangeHistory()">查询</el-button>
                <el-button type="info" size="small" plain @click="resetForm()">重置</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-row>
        <!-- table start -->
        <el-row style="margin-top: 15px;margin-bottom: 20px">
          <hot-table
            ref="changeHistoryTableRef"
            :data-source="changeHistoryTableDataSource"
            :settings="changeHistoryTableSettings"
            col-settings-key="changeHistory"
          >
            <hot-column :has-tip="true" data="" title="类型" width="150"></hot-column>
            <hot-column :has-tip="true" data="" title="表名" width="150"></hot-column>
            <hot-column :has-tip="true" data="" title="字段描述" width="150"></hot-column>
            <hot-column :has-tip="true" data="" title="新值" width="150"></hot-column>
            <hot-column :has-tip="true" data="" title="旧值" width="150"></hot-column>
            <hot-column :has-tip="true" data="" title="修改人" width="150"></hot-column>
            <hot-column :has-tip="true" data="" title="修改时间" date-format="yyyy-MM-DD HH:mm:ss"
                        width="150"></hot-column>
          </hot-table>
          <!-- 分页start -->
          <div class="pg_div">
            <el-pagination
              :current-page="pageConfig.currentPage"
              :layout="pageConfig.layout"
              :page-size="pageConfig.pageSize"
              :page-sizes="pageConfig.pageSizes"
              :total="pageConfig.total"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            />
          </div>
          <!-- 分页end -->
        </el-row>
        <!-- table end -->
      </el-row>
    </el-col>
    </el-form>
  </el-dialog>
</template>

<script>

import ebOrder from "@/api/ebOrder";

export default {
  name: 'changeHistoryUpBox',
  props: {
    changeHistoryVisibleFlagInit: Boolean,
    ebOrder: Object,
    ebBlPlan: Object,
  },
  data() {
    return {
      searchData: {
        tableName: null,
        fieldDescription: null,
        newValue: null,
        oldValue: null,
        modifier: null,
        modifyTimeFrom: null,
        modifyTimeTo: null
      },
      changeHistoryVisible: false,
      // 表格数据
      changeHistoryTableDataSource: [],
      // 表格设置
      changeHistoryTableSettings: {
        height: 300,
        stretchH: 'none', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
        showSelection: false //把checkBox隐藏
      },
      // 分页
      pageConfig: {
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0,
        pageSize: 10,
        pagerCount: 10,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100]
      },
      //日期设置
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    }
  },
  // 监听
  watch: {
    changeHistoryVisibleFlagInit() {
      let self = this
      self.changeHistoryVisible = true
      this.queryChangeHistory()
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      this.pageConfig.pageSize = val
      let self = this
      self.queryChangeHistory()
    },
    // currentPage 改变时会触发
    handleCurrentChange(val) {
      this.pageConfig.currentPage = val
      let self = this
      self.queryChangeHistory()
    },
    //重置
    resetForm() {
      this.searchData = {
        tableName: null,
        fieldDescription: null,
        newValue: null,
        oldValue: null,
        modifier: null,
        modifyTimeFrom: null,
        modifyTimeTo: null
      }
    },
    //查询 （未实现）
    queryChangeHistory() {
      let self = this
      for (let s in self.searchData) {
        if (self.searchData[s] !== "") {
          num++
        }
      }
      if (num === 0) {
        self.$coreMethods.message('warning', '至少输入一个查询条件')
      } else {
        //调用查询为表格赋值
      }
    },
    //子组件
    clickModule() {

    }
  }
}
</script>

<style>
.customWidthChangeHistory1 {
  width: 77%;
  height: 580px;
}

.el-dialog__body {
  padding: 0px;
}

</style>
